import {
  createXlsxSingleTb,
  parseSheetName,
  downloadZip,
} from "../../../../service/excel";
import ExcelJS from "exceljs";
import {
  option_warn_limit,
  option_period_time_obj,
  option_measure_time_obj,
  option_symptoms,
} from "../../../../service/option";
import moment from "moment";

const renderCellStyle = ({ data, field }) => {
  return {
    ...([
      "systolic_blood_pressure",
      "diastolic_blood_pressure",
      "heart_rate",
    ].includes(field) &&
    (data < option_warn_limit[field].down || data > option_warn_limit[field].up)
      ? { font_color: "e35b68" }
      : {}),
    ...(["bmi"].includes(field) &&
    (data < option_warn_limit[field].down || data > option_warn_limit[field].up)
      ? { font_color: "e35b68" }
      : {}),
    ...(["glucose"].includes(field) &&
    (data < option_warn_limit[field].down || data > option_warn_limit[field].up)
      ? { font_color: "e35b68" }
      : {}),
  };
};

const sheetName = {
  health: "健康行為",
  heartbeat: "血壓/心跳​",
  sugar: "血糖",
  uncomfortable: "不適症狀",
  weight: "體重",
};
const headColumns = {
  health: [
    {
      key: "member_name",
      field: "member_name",
      header: "姓名",
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "date",
      field: "date",
      header: "日期",
      isDate: true,
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "score",
      field: "score",
      header: "總分",
      decimalShowRaw: true,
      exportOptions: {
        width: 15,
      },
    },
  ],
  heartbeat: [
    {
      key: "member_name",
      field: "member_name",
      header: "姓名",
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "date",
      field: "date",
      header: "日期",
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "type",
      field: "type",
      header: "時段",
      exportOptions: {
        width: 15,
        formatVal: ({ allData }) => {
          return option_period_time_obj[allData.type].label;
        },
      },
    },
    {
      key: "systolic_blood_pressure",
      field: "systolic_blood_pressure",
      header: "收縮壓",
      decimalShowRaw: true,
      exportOptions: {
        width: 15,
        bodyColStyles: ({ data, field }) => renderCellStyle({ data, field }),
      },
    },
    {
      key: "diastolic_blood_pressure",
      field: "diastolic_blood_pressure",
      header: "舒張壓",
      decimalShowRaw: true,
      exportOptions: {
        width: 15,
        bodyColStyles: ({ data, field }) => renderCellStyle({ data, field }),
      },
    },
    {
      key: "heart_rate",
      field: "heart_rate",
      header: "心跳",
      decimalShowRaw: true,
      exportOptions: {
        width: 15,
        bodyColStyles: ({ data, field }) => renderCellStyle({ data, field }),
      },
    },
  ],
  sugar: [
    {
      key: "member_name",
      field: "member_name",
      header: "姓名",
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "date",
      field: "date",
      header: "日期",
      isDate: true,
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "type",
      field: "type",
      header: "量測時間",
      exportOptions: {
        width: 15,
        formatVal: ({ allData }) => {
          return allData.status === 1
            ? option_measure_time_obj[allData.type]?.label
            : "無量測";
        },
        bodyColStyles: ({ allData }) => {
          return {
            font_color: allData.status === 1 ? "000000" : "e35b68",
          };
        },
      },
    },
    {
      key: "glucose",
      field: "glucose",
      header: "血糖",
      decimalShowRaw: true,
      exportOptions: {
        width: 15,
        formatVal: ({ allData }) => {
          return allData.status === 1 ? allData.glucose : "-";
        },
        bodyColStyles: ({ data, field }) => renderCellStyle({ data, field }),
      },
    },
  ],
  uncomfortable: [
    {
      key: "member_name",
      field: "member_name",
      header: "姓名",
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "date",
      field: "date",
      header: "日期",
      isDate: true,
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "type",
      field: "type",
      header: "時段",
      exportOptions: {
        width: 15,
        formatVal: ({ allData }) => {
          return option_period_time_obj[allData.type].label;
        },
      },
    },
    {
      key: "weight",
      field: "weight",
      header: "不適症狀",
      exportOptions: {
        width: 50,
        formatVal: ({ allData }) => {
          return `${option_symptoms
            .filter((item) => allData[item.key] === 1)
            .map((item) => item.label)
            .join("、")}${
            allData.u14 === 1 && allData.u14_other
              ? `(${allData.u14_other})`
              : ""
          }${
            option_symptoms.filter((item) => allData[item.key] === 1).length ===
            0
              ? "無"
              : ""
          }`;
        },
      },
    },
    {
      key: "time",
      field: "time",
      header: "症狀發生時間",
      exportOptions: {
        width: 18,
        formatVal: ({ allData }) => {
          return allData.time
            ? moment(`${moment().format("YYYY-MM-DD")} ${allData.time}`).format(
                "HH:mm"
              )
            : "-";
        },
      },
    },
  ],
  weight: [
    {
      key: "member_name",
      field: "member_name",
      header: "姓名",
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "date",
      field: "date",
      header: "日期",
      isDate: true,
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "type",
      field: "type",
      header: "時段",
      exportOptions: {
        width: 15,
        formatVal: ({ allData }) => {
          return option_period_time_obj[allData.type].label;
        },
      },
    },
    {
      key: "weight",
      field: "weight",
      header: "體重",
      decimalShowRaw: true,
      exportOptions: {
        width: 15,
      },
    },
    {
      key: "bmi",
      field: "bmi",
      header: "BMI",
      decimalShowRaw: true,
      exportOptions: {
        width: 15,
        bodyColStyles: ({ data, field }) => renderCellStyle({ data, field }),
      },
    },
  ],
};

const formatMemeber = async ({ fileBlob, data, serial }) => {
  const workbook = new ExcelJS.Workbook();

  for (let i = 0; i < data.length; i++) {
    const worksheetName = parseSheetName(sheetName[data[i].type]);
    createXlsxSingleTb({
      isNewSheet: true,
      isTitle: false,
      titleOptions: {
        label: worksheetName,
        position: { x: 0, y: 0 },
      },
      totalOptions: {
        isSum: false,
      },
      workbook,
      tbHeadColumns: headColumns[data[i].type],
      tbData: data[i].data,
    });
  }

  const mainBuffer = await workbook.xlsx.writeBuffer();
  const mainFileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const mainBlob = new Blob([mainBuffer], { type: mainFileType });
  fileBlob.push({
    filename: `${serial}_${data[0].data[0].member_name}.xlsx`,
    blob: mainBlob,
  });
};

export const createRecordExcel = async ({ data, finishAction }) => {
  let fileBlob = [];

  for (let i = 0; i < data.length; i++) {
    let formatData = Object.entries(data[i])
      .map(([type, val]) => ({
        type,
        data: val,
      }))
      .filter((item) => item.data?.length > 0);

    if (formatData === 0) continue;

    await formatMemeber({
      fileBlob,
      data: formatData,
      serial: String(i + 1).padStart(4, "0"),
    });
  }

  console.log(fileBlob);

  downloadZip({
    filename: "會員紀錄",
    fileBlob,
    finishAction,
  });
};
